import * as ReactGA from 'react-ga';

export const gaEnteredChat = (course: string) => {
  ReactGA.event({
    category: 'Chat',
    action: `Entered chat: ${course}`
  });
}
